import { FC, useState, useEffect } from "react";
import { LineChart } from "./LineChart";
import { BarChart } from "./BarChart";
import { Chart } from "./types";

interface CustomChartProps {
  chart: Chart;
}

export const CustomChart: FC<CustomChartProps> = ({ chart }) => {
  const lineChartData: Chart["chartData"] = chart.chartData;

  const lines = [
    {
      dataKey: "dataValue1",
      name: chart.legendName1,
      color: "#8884d8",
    },
    {
      dataKey: "dataValue2",
      name: chart.legendName2,
      color: "#82ca9d",
      dashed: true,
    },
  ];

  return chart.chartType === "Bars" ? (
    <BarChart {...chart} />
  ) : (
    <LineChart data={lineChartData} xAxisKey="labelName" lines={lines} />
  );
};
